<template>
  <Layout>
    <EntitlementPersonLayout />
    <section class="p_main">
      <h5>Bank Information</h5>
      <div class="bg-white rounded box-shadow p-3" v-if="Object.keys(bank).length === 0">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <div class="row pb-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0 medium lh-150 black strong">
                  <strong class="d-block text-dark pb-1">Bank Name</strong>
                  {{ bank ? bank.bank != null ? bank.bank.bank_desc : 'N/A' : 'N/A'   }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0 medium lh-150">
                  <strong class="d-block text-dark pb-1">Branch Name</strong>
                  {{  bank.branch_name != null ? bank.branch_name : "N/A" }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <div class="media text-muted">
                  <p class="media-body pb-2 mb-0 medium lh-150">
                    <strong class="d-block text-dark pb-1">Account No</strong>
                    {{ bank.account_no != null ? bank.account_no : "N/A" }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0 medium lh-150 black strong">
                  <strong class="d-block text-dark pb-1">Bank Address</strong>
                  {{ bank ? bank.bank != null ? bank.bank.bank_address : 'N/A' : 'N/A'   }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0 medium lh-150 black strong">
                  <strong class="d-block text-dark pb-1">Remarks</strong>
                  {{ bank.remarks != null ? bank.remarks : "N/A" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white rounded box-shadow p-3" v-if="Object.keys(bank).length === 0 && !flag">
        <h5 style="text-align: center">No Data Found</h5>
      </div>
    </section>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import EntitlementPersonLayout from './layout'
import http from "@state/http";

export default {
  page: {
    title: 'Entitlement Person',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, EntitlementPersonLayout },
  data() {
    return {
      title: 'Entitlement Person Bank Info',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Entitlement Person Bank Info',
          active: true,
        },
      ],
      bank: [],
      flag: false
    }
  },
  mounted() {
    this.getBank();
  },

  methods: {
    getBank() {
      let ses_id = this.$route.params.ses_id;
      http.get("api/entitlement-person/bank/list/" + ses_id).then(response => {
        if (!response.error) {
          this.flag = true;
          let data = response.data;
          this.bank = data.bank;
        }
      });
    }
  },
}
</script>

<style scoped>
.scrollable-table {
  overflow-x: auto;
  white-space: nowrap;
}
</style>